/**
 * Save and Settings System for "Bertahan Dari Anomali"
 * Persists high scores and user audio/graphics settings via localStorage.
 */

export interface GameSaveData {
  saveVersion: number;
  highScore: number;
  enemiesDefeatedTotal: number;
  clearedRuns: number;
  settings: {
    bgmEnabled: boolean;
    sfxEnabled: boolean;
    bgmVolume: number;
    sfxVolume: number;
    screenShake: boolean;
    damageNumbers: boolean;
  };
}

const STORAGE_KEY = "bertahan_dari_anomali_save_v1";

const DEFAULT_SAVE: GameSaveData = {
  saveVersion: 1,
  highScore: 0,
  enemiesDefeatedTotal: 0,
  clearedRuns: 0,
  settings: {
    bgmEnabled: true,
    sfxEnabled: true,
    bgmVolume: 0.5,
    sfxVolume: 0.8,
    screenShake: true,
    damageNumbers: true,
  },
};

export class SaveSystem {
  public static load(): GameSaveData {
    if (typeof window === "undefined" || !window.localStorage) {
      return { ...DEFAULT_SAVE };
    }

    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { ...DEFAULT_SAVE };
      const parsed = JSON.parse(raw);
      if (parsed.saveVersion === 1) {
        return {
          ...DEFAULT_SAVE,
          ...parsed,
          settings: { ...DEFAULT_SAVE.settings, ...parsed.settings },
        };
      }
    } catch {
      // Fallback
    }

    return { ...DEFAULT_SAVE };
  }

  public static save(data: GameSaveData) {
    if (typeof window === "undefined" || !window.localStorage) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      // Ignore quota errors
    }
  }
}
